import { render, staticRenderFns } from "./merchantUpdateStore.vue?vue&type=template&id=120be05e"
import script from "./merchantUpdateStore.vue?vue&type=script&lang=js"
export * from "./merchantUpdateStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports